var _defs, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 445.27 408.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff931e;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 148.03,
    x2: 270.44,
    y2: 148.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#64ff70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004a37"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-av") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "278.15 112.21 445.27 112.21 278.15 408.27 169.51 222.04 127.73 222.04 171.9 148.03 276.95 330.67 383.2 148.03 341.42 148.03 319.93 185.03 278.15 112.21"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "270.44 174.04 248.95 212.24 170.71 75.21 64.46 257.85 148.03 257.85 170.71 296.05 0 296.05 170.71 0 270.44 174.04"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAv);
export default __webpack_public_path__ + "static/media/logo-av.c0c5ef32bc0b6eab344056049b26f5ae.svg";
export { ForwardRef as ReactComponent };